
















import { Vue, Component } from 'vue-property-decorator'
import { Confirm, XTextarea } from '@lx-frontend/cvux'

@Component({
  components: {
    Confirm,
    XTextarea
  }
})
export default class RejectReason extends Vue {
  show:boolean = false

  reason = ''

  backInfo = {}

  changeShow(v:boolean, backInfo = {}) {
    this.show = v
    if (v) {
      this.reason = ''
      this.backInfo = backInfo
    }
  }

  onRejectConfirm() {
    this.$emit('success', {
      reason: this.reason,
      backInfo: this.backInfo
    })
  }
}
